<template>
  <div class="main-content">
    <div class="qr-code-customer-page">
      <div class="container">
        <div class="out-side">
          <h3 class="qr-code__title date">{{ dateSplit[0] }}</h3>
          <h3 class="qr-code__title time" :style="{ color: font_color }">
            {{ dateSplit[1] }}
          </h3>
          <h3 class="qr-code__title teacher" :style="{ color: font_color }">
            {{ course_name }} {{ teacher_name }}
          </h3>
          <div class="qr-code__img">
            <CheckInQrCode :schedule-time-id="schedule_time_id"></CheckInQrCode>
          </div>

          <router-link :to="{ name: '會員手動報到' }" class="transparent-btn">
            手動報到
          </router-link>
          <br />
          <router-link :to="{ name: '學員報到' }" class="transparent-btn">
            其它課程
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckInQrCode from '@/components/QrCode/CheckInQrCode';

export default {
  components: {
    CheckInQrCode
  },
  data() {
    return {
      schedule_time_id: this.$route.params.schedule_time_id,
      course_name: this.$route.params.course_name,
      date_time: this.$route.params.date_time,
      teacher_name: this.$route.params.teacher_name,
      font_color: this.$route.params.font_color
    };
  },
  computed: {
    dateSplit() {
      return this.date_time.split(' ');
    }
  }
};
</script>
